var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWfArrowExpand = function SvgWfArrowExpand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "9px",
    viewBox: "0 0 15 9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3171742,5.57042158 C11.818645,5.04392548 11.818645,4.19136881 11.3171742,3.66628424 L5.83527808,-2.04683354 C5.32842956,-2.57332964 4.50900205,-2.57191812 4.00215353,-2.04683354 C3.50068272,-1.52033745 3.50068272,-0.668486536 4.00215353,-0.141990444 L8.57320118,4.61835291 L4.00215353,9.37728474 C3.50068272,9.90378083 3.50068272,10.7556317 4.00215353,11.2821278 C4.50900205,11.8079182 5.32842956,11.8079182 5.83527808,11.2821278 L11.3171742,5.57042158 Z",
    id: "Path",
    fill: "#BEC8D2",
    fillRule: "nonzero",
    transform: "translate(7.659664, 4.617647) rotate(-270.000000) translate(-7.659664, -4.617647) "
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWfArrowExpand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wf_arrow_expand.06e6e9bd.svg";
export { ForwardRef as ReactComponent };